import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import { useNavigate } from "react-router-dom";

import { Header, Lists } from "../../components";
import { useAuth } from "../../context/AuthContext";
import { riwayatDinas } from "../../helpers/ApiPresensi";
import { decryptLocalStorage } from "../../helpers/SecureStorage";
import { showError, showSessionExpired } from "../../helpers/Toast";

const RiwayatDinas = () => {
  const { handleSessionExpired } = useAuth();
  const navigate = useNavigate();
  const [riwayat, setriwayat] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  const token = decryptLocalStorage(process.env.REACT_APP_LOCAL_STORAGE_TOKEN);

  const getRiwayat = async () => {
    try {
      const response = await fetch(riwayatDinas, {
        method: "GET",
        mode: "cors",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      if (!response.ok) {
        if (response.status === 401) {
          handleSessionExpired();
          await showSessionExpired();
          navigate("/");
          return;
        }
        showError("Gagal memuat riwayat dinas");
        return;
      }

      const data = await response.json();
      setriwayat(data.data || []);
    } catch (error) {
    } finally {
      setIsLoading(false);
    }
  };

  const openBukti = (item) => {
    window.open(item.file_bukti, "_blank");
  };

  useEffect(() => {
    getRiwayat();
  }, []);

  return (
    <div className="flex flex-col min-h-screen bg-gray-50">
      <Helmet>
        <title>Riwayat Dinas</title>
      </Helmet>

      <div
        className="w-full px-4 pt-6 pb-14"
        style={{ background: "linear-gradient(135deg, #FFB703 0%, #e6a200 100%)" }}
      >
        <Header to="/home" title="Riwayat Dinas" />
      </div>

      <div className="flex-grow px-4 pb-6" style={{ marginTop: -40 }}>
        {isLoading ? (
          <div className="space-y-3 mt-2">
            {[1, 2, 3].map((i) => (
              <div key={i} className="bg-white rounded-2xl h-24 animate-pulse" />
            ))}
          </div>
        ) : riwayat && riwayat.length > 0 ? (
          riwayat.map((item, index) => (
            <Lists
              riwayatdinas
              key={index}
              text={item.tgl}
              text2={item.keterangan}
              text3={item.status}
              text4={item.jumlah_hari}
              onClick={() => openBukti(item)}
            />
          ))
        ) : (
          <div className="bg-white rounded-2xl shadow-sm border border-gray-100 px-4 py-10 mt-2 text-center">
            <svg className="w-12 h-12 mx-auto mb-3 text-gray-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M21 13.255A23.931 23.931 0 0112 15c-3.183 0-6.22-.62-9-1.745M16 6V4a2 2 0 00-2-2h-4a2 2 0 00-2 2v2m4 6h.01M5 20h14a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
            </svg>
            <p className="text-sm text-gray-400">Belum ada riwayat dinas</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default RiwayatDinas;
